import {useState, useEffect} from 'react';

import { useSelector,useDispatch } from 'react-redux';

import RmvendorquotationDashboard from 'components/rmvendorquotation/RmvendorquotationDashboard';
import { setRmvendorquotationDashboardRmvendorquotationList } from 'store/slice/PharmaSlice';
export default function QuotationmgmtActionImpl(){
    const dispatch = useDispatch();
    const {rmvendorquotationList} = useSelector((state)=>state.pharmaslice);
    const {rawdemandObj} = useSelector((state)=>state.pharmaslice.rawdemandDashboard);

    useEffect(()=>{
        console.log("rawdemandObj.id=>"+rawdemandObj.id)
        console.log("rmvendorquotationList=>"+JSON.stringify(rmvendorquotationList))
        dispatch(setRmvendorquotationDashboardRmvendorquotationList(
            rmvendorquotationList.filter(rmvendorquotationObj => rmvendorquotationObj.rawdemandid===parseInt(rawdemandObj.id))
        ))
    },[rawdemandObj])
    

    return (
        <>
       <RmvendorquotationDashboard/>
        </>
    )
}